(() => {
  function init(root = document) {
    root.querySelectorAll('.dm-account__nav').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const update = () => {
        const current = location.hash || '#orders';
        nav.querySelectorAll('a[href^="#"]').forEach(link => {
          if (link.getAttribute('href') === current) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      window.addEventListener('hashchange', update);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
